import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_user/courses')({
  beforeLoad: async ({ context }) => {
    const user =
      context.auth.user ?? (await context.auth.userRefetch().catch(() => null));

    if (!user) {
      throw redirect({ to: '/sign-in' });
    }

    if (!user.user_can_take) {
      throw redirect({
        to: '/payment/select-course',
        search: {
          status: undefined,
          session_id: undefined,
        },
      });
    }

    if (!user.is_email_verified) {
      throw redirect({
        to: '/verify-email',
        search: {
          email: user.email,
          token: undefined,
        },
      });
    }
  },
});
